import { makeStyles } from "@material-ui/styles";

const printableStyles = makeStyles(() => ({
	printOnly: {
		display: "none",
		"@media print": {
			display: "inherit"
		}
	}
}));

export default printableStyles;
